import React from 'react';
import {
  NestedForm, Link, Grid, InputField, ListItem, useWindowSize,
} from 'vindi-ds-components';
import { PrPlusCircle, PrClose } from 'vindi-ds-icons/pr';

function PhoneForm({ values }) {
  const { isMobile } = useWindowSize();
  const MAX_PHONES_NUMBERS = 3;

  return (
    <NestedForm
      name='phones_attributes'
      css={{ width: isMobile ? '100%' : 'calc(65% - 100px)' }}
      addButton={(
        <Link href='#add' disabled={values.phones_attributes.length >= MAX_PHONES_NUMBERS} icon={<PrPlusCircle />} withIcon>
          Adicionar número
        </Link>
      )}
      removeButton={(
        <Link href='#remove' icon={<PrClose />} withIcon>
          Remover
        </Link>
      )}
    >
      {({ index }) => {
        const hasExtension = values.phones_attributes[index].phone_type === 'landline';
        const getValues = values;
        if (!hasExtension) {
          getValues.phones_attributes[index].extension = '';
        }
        if (isMobile) {
          getValues.phones_attributes[index].phone_type = 'mobile';
        }
        return (
          <Grid container spacing={3} style={{ maxWidth: '650px', marginTop: '8px' }}>
            <Grid item xs={12} md={5}>
              <InputField
                label={`Tipo de dispositivo ${index + 1}`}
                name='phone_type'
                placeholder=''
                select
              >
                <ListItem value='mobile'>Celular</ListItem>
                <ListItem value='landline'>Fixo</ListItem>
              </InputField>
            </Grid>
            <Grid item xs={12} md={hasExtension ? 4 : 7}>
              <InputField label={`Número ${index + 1}`} name='local' mask='cell' />
            </Grid>
            {hasExtension && (
              <Grid item xs={12} md={3}>
                <InputField label={`Ramal ${index + 1}`} name='extension' type='number' />
              </Grid>
            )}
          </Grid>
        );
      }}
    </NestedForm>
  );
}

export default PhoneForm;
